module.exports = __webpack_public_path__ + "img/edit_adjust.45fe041.svg";